module.exports = __webpack_public_path__ + "img/millet.be5030ca.webp";